import React from 'react';
import { ISummaryList } from './ISummary';

const SummaryList = ({ name, cy, children }: ISummaryList) => (
  <dl>
    <dt>{name}</dt>
    <dd data-cy={cy}>
      {children}
    </dd>
  </dl>
);

export default SummaryList;
